import type { ReactNode } from "react";

import { StatePanel, type StatePanelState } from "./StatePanel";

export interface AccessStateProps {
  state: StatePanelState;
  title: string;
  description: string;
  action?: ReactNode;
}

/**
 * A full-page gate shown before the shell exists -- loading a session, a denied
 * profile, a failed bootstrap.
 *
 * It owns the `<main>` landmark and an `<h1>` because at this point no route
 * has rendered a heading, and a page whose only content is a status message
 * still needs exactly one top-level heading.
 */
export function AccessState({ action, description, state, title }: AccessStateProps) {
  return (
    <main className="access-state">
      <StatePanel
        action={action}
        description={description}
        headingLevel={1}
        state={state}
        title={title}
      />
    </main>
  );
}
